<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="modal fade"  bsModal #AddUnitPopup="bs-modal" [config]="modalConfig" id="AddUnitModal" role="dialog" style="padding:0 !important;">
  <div class="modal-dialog modal-xxl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle" i18n="@@Add_Unit">Add Unit</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true" id="addUnit-close">&times;</span>
        </button>
      </div>
      <div class="modal-body addunit_modalbody p-3">
        <div class="mb-2">
          <app-call-script [section]="section"></app-call-script>
        </div>
        <div class="add_unit_search_filter_sec" *ngIf="showLocationInfo">
          <div class="filter_date">
            <div class="form-group mb-0">
              <label i18n="@@Date_Needed">Date Needed
                <span class="required">*</span>
              </label>
              <ejs-datepicker class="form-control p-0 ejsgrid-height h-auto" [min]='MinDate' [max]="MaxDate"
                [allowEdit]="false" (ngModelChange)="dateChanged($event)" [(ngModel)]="selectedDate" required
                format='MM/dd/yyyy' floatLabelType='Always' (renderDayCell)="onDatePickerLoad($event)"
                appHighlightCallScriptFields [fieldName]="'selectedDate'" [linkedFieldsList]="unitSelectionFields">

              </ejs-datepicker>
              <div class="alert alert-danger" *ngIf="isDateRequired">
                <span>Date is required</span>
              </div>
            </div>
          </div>
          <div class="filter_zip_radius">
            <div class="filter_zip">
              <label for="ZipCode" i18n="@@Zip_Code">Zip / Postal Code </label>
              <input type="text" class="form-control" id="ZipCode" [disabled]="selectedDate === ''"
                [(ngModel)]="selectedZip" appHighlightCallScriptFields (keypress)="validateZipInput($event)" [fieldName]="'selectedZip'"
                [linkedFieldsList]="unitSelectionFields" >
            </div>
            <div class="filter_radius">
              <label for="inputcompanyname">Radius</label>
              <input type="number" class="form-control inputresp" placeholder="Miles" [(ngModel)]="selectedRadius" min="0" step="1"
                [disabled]="selectedDate === ''" appHighlightCallScriptFields [fieldName]="'selectedRadius'" (keypress)="onlyNumberKey($event)"
                [linkedFieldsList]="unitSelectionFields">
            </div>
            <div class="filter_search_butt">
              <button type="button" class="btn btn-primary text-uppercase w-100" (click)="getLocationList()"
                i18n="@@Search" [disabled]="selectedDate === '' || selectedRadius === '' || selectedZip === ''"><i
                  class="fa fa-search"></i></button>
            </div>
          </div> 
          <div class="or_text text-center">
            <label class="mt-4 pt-2 mb-0" i18n="@@OR">OR</label>
          </div>
          <div class="filter_location">
            <label for="inputcompanyname" i18n="@@Select_Location">Store Name
              <span class="required">*</span>
            </label>
            <select class="form-select" (ngModelChange)="addLocation($event)" [(ngModel)]="selectedLocation"
              [disabled]="selectedDate === '' || isEditReservation || isIPBasedLogin || GeolocationBasedLogin || isEditInquiry"
              appHighlightCallScriptFields [fieldName]="'selectedLocation'" [linkedFieldsList]="unitSelectionFields">
              <option i18n="@@Select_Location" value="0">Select Store</option>
              <option [ngValue]="item.Id" *ngFor="let item of storeList">{{item.Name}}</option>
            </select>
            <div class="alert alert-danger" *ngIf="selectedLocation == 0">
              <span>Location is required</span>
            </div>
          </div>
        </div>

        <div class="addunit_out" style="height: 650px !important;">
          <div class="addunit_search_filter d-inline-flex align-items-center text-nowrap" *ngIf="isUnitTypeOpened">
            <div class="unit_sel_box custom-width">
              <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedSize"
                (change)="filterList(true)">
                <option value="0" i18n="@@Size">Unit Size</option>
                <option [value]="item" *ngFor="let item of unitTypeSizeList">{{item}}</option>
              </select>
            </div>
            <div class="unit_sel_box custom-width">
              <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedStatus"
                (change)="getUnitTypes(selectedLocation > 0 ? selectedLocation : lastAccessedFacility,2)">
                <option value="0" i18n="@@Status">All Status</option>
                <option [value]="item.Name" *ngFor="let item of filterStatusList">{{item.Name}}</option>
              </select>
            </div>
            <div class="unit_sel_box custom-width">
              <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedCapacity"
                (change)="filterList(true)">
                <option value="0" i18n="@@Capacity">Capacity</option>
                <option [value]="item" *ngFor="let item of unitTypeCapacityList">{{item}}</option>
              </select>
            </div>
            <div class="unit_sel_box custom-width">
              <ejs-dropdownlist id='employees' [dataSource]='filterCategoryList' [disabled]="isSearchedByUnitNum"
                [(ngModel)]="selectedCategory" [fields]='fields' [popupHeight]='height' [placeholder]='watermark'
                (ngModelChange)="changeCategory($event)" style="word-break:break-all">

                <ng-template #itemTemplate let-data>
                  <div><img class="empImage" [src]="data.LargeImageURL" *ngIf="data.Id != 0" />
                    <div class="ename"> {{data.Name}} </div>
                  </div>
                </ng-template>
                <ng-template #valueTemplate let-data>
                  <div><img class="valueTemp" [src]="data.LargeImageURL" height="20px" width="20px"
                      *ngIf="data.Id != 0" />
                    <div class="name"> {{data.Name}} </div>
                  </div>
                </ng-template>
              </ejs-dropdownlist>
            </div>
            <div class="unit_sel_box filtr_attr custom-width">
              <ejs-dropdownlist id='employees' [dataSource]='filterAttributeList' [disabled]="isSearchedByUnitNum"
                [(ngModel)]="selectedAttribute" [fields]='fields' [popupHeight]='height' [placeholder]='watermark1'
                (ngModelChange)="filterList(true)">
                <ng-template #itemTemplate let-data>
                  <div><img class="empImage" [src]="data.LargeImageURL" />
                    <div class="ename"> {{data.Name}} </div>
                  </div>
                </ng-template>
                <ng-template #valueTemplate let-data>
                  <div><img class="valueTemp" [src]="data.LargeImageURL" height="20px" width="20px" />
                    <div class="name"> {{data.Name}} </div>
                  </div>
                </ng-template>
              </ejs-dropdownlist>
            </div>
            <div class="unit_sel_box custom-width">
              <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedPricingCategory"
                (change)="filterList(true)">
                <option value="0" i18n="@@Pricing Category">Pricing Category</option>
                <option [value]="item.PricingCategoryName" *ngFor="let item of pricingCategoryList">{{item.PricingCategoryName}}</option>
              </select>
            </div>
            <div class="unit_sel_box custom-width">
              <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedAmenity" (change)="filterList(true)">
                <option value="0">Amenities</option>
                <option *ngFor="let amenity of amenitiesList" [value]="amenity">
                  {{amenity}}
                </option>
              </select>
            </div>
            <button class="btn btn-outline-primary clear_all me-2" type="button" (click)="clearAllFilter()">X</button>
            <div class="mobile_filter">
              <div class="accordion mobile_acc" id="mobileaccordion">
                <div class="card">
                  <div class="card-header" id="mobfilter">
                    <h2 class="mb-0">
                      <button class="btn btn-link w-100 text-left" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        <i class="fas fa-filter"></i> Filters
                        <i class="fas fa-caret-right"></i>
                      </button>
                    </h2>
                  </div>

                  <div id="collapseOne" class="collapse" aria-labelledby="mobfilter" data-bs-parent="#mobileaccordion">
                    <div class="card-body">
                      <div class="unit_sel_box custom-width">
                        <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedSize"
                          (change)="filterList(true)">
                          <option value="0" i18n="@@Size">Unit Size</option>
                          <option [value]="item" *ngFor="let item of unitTypeSizeList">{{item}}</option>
                        </select>
                      </div>
                      <div class="unit_sel_box custom-width">
                        <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedStatus"
                          (change)="getUnitTypes(selectedLocation > 0 ? selectedLocation : lastAccessedFacility,2)">
                          <option value="0" i18n="@@Status">All Status</option>
                          <option [value]="item.Name" *ngFor="let item of filterStatusList">{{item.Name}}</option>
                        </select>
                      </div>
                      <div class="unit_sel_box custom-width">
                        <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedCapacity"
                          (change)="filterList(true)">
                          <option value="0" i18n="@@Capacity">Capacity</option>
                          <option [value]="item" *ngFor="let item of unitTypeCapacityList">{{item}}</option>
                        </select>
                      </div>
                      <div class="unit_sel_box custom-width">
                        <ejs-dropdownlist id='employees' [dataSource]='filterCategoryList'
                          [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedCategory" [fields]='fields'
                          [popupHeight]='height' [placeholder]='watermark' (ngModelChange)="changeCategory($event)">
                          <ng-template #itemTemplate let-data>
                            <div><img class="empImage" [src]="data.LargeImageURL" *ngIf="data.Id != 0" />
                              <div class="ename"> {{data.Name}} </div>
                            </div>
                          </ng-template>
                          <ng-template #valueTemplate let-data>
                            <div><img class="valueTemp" [src]="data.LargeImageURL" height="20px" width="20px"
                                *ngIf="data.Id != 0" />
                              <div class="name"> {{data.Name}} </div>
                            </div>
                          </ng-template>
                        </ejs-dropdownlist>
                      </div>
                      <div class="unit_sel_box filtr_attr custom-width">
                        <ejs-dropdownlist id='employees' [dataSource]='filterAttributeList'
                          [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedAttribute" [fields]='fields'
                          [popupHeight]='height' [placeholder]='watermark1' (ngModelChange)="filterList(true)">

                          <ng-template #itemTemplate let-data>
                            <div><img class="empImage" [src]="data.LargeImageURL" />
                              <div class="ename"> {{data.Name}} </div>
                            </div>
                          </ng-template>
                          <ng-template #valueTemplate let-data>
                            <div><img class="valueTemp" [src]="data.LargeImageURL" height="20px" width="20px" />
                              <div class="name"> {{data.Name}} </div>
                            </div>
                          </ng-template>
                        </ejs-dropdownlist>
                      </div>
                      <div class="unit_sel_box custom-width">
                        <select class="form-select" [disabled]="isSearchedByUnitNum" [(ngModel)]="selectedPricingCategory"
                          (change)="filterList(true)">
                          <option value="0" i18n="@@Pricing Category">Pricing Category</option>
                          <option [value]="item.PricingCategoryName" *ngFor="let item of pricingCategoryList">{{item.PricingCategoryName}}</option>
                        </select>
                      </div>
                      <button class="btn btn-outline-primary" type="button" (click)="clearAllFilter()">X</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit_form_rgt">
              <div class="unit_sel_box pr-0">
                <input type="text" class="form-control border-right-0 " placeholder="Unit #" [(ngModel)]="searchUnitNum"
                  name="" style="width: inherit;">
                <button type="button" class="search_close" (click)="resetSearch()"><span
                    aria-hidden="true">×</span></button>
              </div>
              <button type="button" class="btn btn-primary rounded-0" (click)="searchByUnitNum()"
                [disabled]="searchUnitNum === ''" i18n="@@Search"><i class="fa fa-search"></i></button>
            </div>

          </div>

          <div id="AddUnitLocation">
            <div class="selecting_list" *ngIf="selectedUnits.length !== 0">
              <div class="select_list" *ngFor="let item of selectedUnits">
                {{item.UnitNumber}}
                <a class="unit_close" (click)="removeSelectedUnit(item.UnitId)">&nbsp;</a>
              </div>
            </div>
            <div *ngIf="!isSearchedByUnitNum">
              <div class="card" *ngFor="let item of locationList;">
                <div class="card-header">
                  <h5 class="mb-0">
                    <a role="button" href="javascript:void(0)" [id]="'removecollapse' + item.Id" (click)="toggleCollapse(item.Id);getUnitTypes(item.Id,1)"
                      [attr.aria-expanded]="isMainExpanded(item.Id)">
                      <i class="fa rgt_arr fa-caret-left" [id]="'MAINID' + item.Id" style="top: -2px;"></i></a>
                    <a class="storeinfo_warehouse" (click)="onClickStore(item.Id)">&nbsp;</a>
                    <app-store-info [storeInfoFacId]="item.Id" [isFromUnitInfo]="true"></app-store-info>
                    {{item.Name}} - {{item.Address}} <span *ngIf="item.Distance !== ''">({{item.Distance}}
                      Miles)</span>
                  </h5>
                </div>
                <div class="collapse multi-collapse" [id]="'ID' + item.Id" [class.show]="isMainExpanded(item.Id)">
                <div class="card-body p-0">
                    <div class="row mx-0">
                      <div class="scroll_outer NoPadding">
                        <div class="scroll_inner_small">
                          <div class="normal_table w-100">
                            <table class="table border-0 table-hover mb-0">
                              <colgroup>
                                <col style="width: 6%;">
                                <col style="width: 15%;">
                                <col style="width: 15%;">
                                <col style="width: 20%;">
                                <col style="width: 15%;">
                                <col style="width: 15%;">
                              </colgroup>
                              <thead>
                                <tr>
                                  <th scope="col">&nbsp;</th>
                                  <th scope="col" i18n="@@Unit_Size">Unit Type Size</th>
                                  <th scope="col" i18n="@@Unit_Size">Description</th>
                                  <th scope="col" i18n="@@Category">Category</th>
                                  <th scope="col" i18n="@@Capacity">Capacity</th>
                                  <th scope="col" i18n="@@Available_Units">Available Units</th>
                                  <th scope="col" i18n="@@Competitors_Avg">Competitor's Avg</th>
                                </tr>
                              </thead>
                              <tbody>
                              </tbody>
                              <tbody *ngFor="let unitTypeItems of item.UnitTypeList">
                                <tr class="par" *ngIf="unitTypeItems.display">
                                  <td class="align-middle">
                                    <a class="tab_clic_1"
                                    role="button"
                                    [attr.aria-expanded]="isExpanded(unitTypeItems.UnitTypeId)"
                                    (click)="getUnitList(unitTypeItems.UnitTypeId, item.Id); toggleUnitCollapse(unitTypeItems.UnitTypeId)">
                                      <i class="fa rgt_arr_Unit fa-caret-left" id="ACID{{unitTypeItems.UnitTypeId}}"></i>
                                    </a>
                                  </td>
                                  <td class="align-middle">{{unitTypeItems.UnitTypeSize}}
                                    <i class="fa fa-exclamation-triangle text-warning ms-2"
                                      title="Not Available for Reservation" *ngIf="unitTypeItems.Warning"></i>
                                  </td>
                                  <td>
                                    {{unitTypeItems?.Description}}
                                  </td>
                                  <td><img *ngIf="unitTypeItems.CategoryLargeImageURL != null"
                                      [src]="unitTypeItems.CategoryLargeImageURL" [title]="unitTypeItems.CategoryName"
                                      style="height: 26px;" /></td>
                                  <td class="align-middle">{{unitTypeItems.Capacity}}</td>
                                  <td class="align-middle">{{unitTypeItems.AvailableUnits}}</td>
                                  <td class="align-middle">
                                    <span *ngIf="unitTypeItems.CompetitorMarketRate?.IsMatched">{{unitTypeItems.CompetitorMarketRate.AverageOccupiedRent | currency:'USD':'symbol':'1.2-2'}}</span>
                                    <span class="list-icon" style="cursor:pointer;" title="View competitor rates"
                                      *ngIf="unitTypeItems.CompetitorMarketRate?.IsMatched" (click)="openCompetitorRateDetail(unitTypeItems, competitorRateDetailModal)"></span>
                                    <span class="globe-icon" style="cursor:pointer;" title="View competitor locations"
                                      *ngIf="unitTypeItems.CompetitorMarketRate?.IsMatched" (click)="openCompetitorMapModal(unitTypeItems, competitorMapModal)"></span>
                                  </td>
                                </tr>
                                <tr [id]="'IDUnitType' + unitTypeItems.UnitTypeId"
                                class="bg-white"
                                [ngClass]="{'collapse': true, 'show': isExpanded(unitTypeItems.UnitTypeId)}"
                                [style.display]="isExpanded(unitTypeItems.UnitTypeId) ? 'table-row' : 'none'">
                                  <td colspan="7" class="expandedUnits">
                                    <table class="inner_table table table-responsive table-hover mb-0">
                                      <colgroup>
                                        <col style="width: 4%;">
                                        <col style="width: 12%;">
                                        <col style="width: 12%;">
                                        <col style="width: 8%;">
                                        <col style="width: 13%;">
                                        <col style="width: 17%;">
                                        <col style="width: 17%;">
                                        <col style="width: 17%;">
                                      </colgroup>
                                      <thead>
                                        <tr>
                                          <th scope="col"></th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitNumber', unitTypeItems.UnitTypeId, item.Id)">Unit #
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitNumber'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitNumber'"></span>
                                          </th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('Status', unitTypeItems.UnitTypeId, item.Id)">Status
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'Status'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'Status'"></span>
                                          </th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('Floor', unitTypeItems.UnitTypeId, item.Id)">Floor
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'Floor'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'Floor'"></span>
                                          </th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitLevelAttributeModel', unitTypeItems.UnitTypeId, item.Id)">
                                            Attributes
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitLevelAttributeModel'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitLevelAttributeModel'"></span>
                                          </th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('Rent', unitTypeItems.UnitTypeId, item.Id)">Rent
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'Rent'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'Rent'"></span>
                                          </th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitLevelAmenitiesModel', unitTypeItems.UnitTypeId, item.Id)">Amenities
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitLevelAmenitiesModel'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitLevelAmenitiesModel'"></span>
                                          </th>
                                          <th scope="col" class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitLevelDiscountModel', unitTypeItems.UnitTypeId, item.Id)">
                                            Specials
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitLevelDiscountModel'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitLevelDiscountModel'"></span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody *ngFor="let unitList of unitTypeItems.UnitList">
                                        <tr *ngIf="unitList.display">
                                          <td>
                                            <div class="buss_acc">
                                              <label class="pure-material-checkbox without-text">
                                                <input type="checkbox" [checked]="unitList.selected"
                                                  [disabled]="checkUnitDisabled(unitList.UnitId,unitList.Status, unitTypeItems)"
                                                  [(ngModel)]="unitList.selected"
                                                  (click)="addUnitToList(unitList.UnitId, item.Id,unitTypeItems.UnitTypeId,  $event)">
                                                <span></span>
                                              </label>
                                            </div>
                                          </td>
                                          <td>{{unitList.UnitNumber}}</td>
                                          <td>{{unitList.Status}}</td>
                                          <td>{{unitList.Floor}}</td>
                                          <td><img class="me-2" *ngFor="let imgItem of unitList.UnitLevelAttributeModel"
                                              [src]="imgItem.LargeImageURL" [title]="imgItem.AttributeName"
                                              style="height: 26px;" /></td>
                                          <td>{{unitList.Rent | currency}} <span *ngIf="unitList.InternetPrice > 0"
                                              class="text-success">(Internet Price
                                              {{unitList.InternetPrice | currency}})</span>
                                            <span *ngIf="unitList.BudgetedRent > 0 && !unitList.InternetPrice && miscellaneousSettings?.DisplayBudgetedRent"
                                              class="text-success">
                                              (Budgeted Rent {{ unitList.BudgetedRent | currency}})</span>
                                            <div *ngIf="unitList.BudgetedRent > 0 && unitList.InternetPrice > 0 && miscellaneousSettings?.DisplayBudgetedRent"
                                              class="text-success">
                                              <span style="visibility: hidden">{{ unitList.Rent | currency }}</span>
                                              (Budgeted Rent {{ unitList.BudgetedRent | currency }})
                                            </div>                                           
                                            <span *ngIf="unitList.PricingCategoryId" class="text-success">
                                                ({{unitList.PricingCategoryName}})</span></td>
                                          <td>
                                            <ol>
                                              <li *ngFor="let name of unitList.UnitLevelAmenitiesModel?.AmenityNames">
                                                  {{ name }}
                                              </li>
                                            </ol>
                                          </td>
                                          <td>
                                            <ol>
                                              <li *ngFor="let discItem of unitList.UnitLevelDiscountModel">
                                                {{discItem.DiscountName}}</li>
                                            </ol>
                                          </td>
                                        </tr>
                                      </tbody>
                                      <tbody *ngIf="checkUnitList(unitTypeItems.UnitList)">
                                        <tr>
                                          <td colspan="5">No data Available</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                              <ng-container *ngIf="checkUnitTypeList(item.UnitTypeList)">
                                <tbody>
                                  <tr>
                                    <td colspan="5">No data Available</td>
                                  </tr>
                                </tbody>
                              </ng-container>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isSearchedByUnitNum">
              <div class="card" *ngFor="let item of locationList;">
                <div class="card-header">
                  <h5 class="mb-0">
                    <a data-bs-toggle="collapse" [ngClass]="locationList.length > 1 ? 'collapsed' : 'show'"
                      href=#ID{{item.Id}} id="removecollapse" role="button" aria-expanded="true">
                      <i class="fa rgt_arr fa-caret-left"></i>
                      {{item.Name}}</a>
                    <span class="unit_close">&nbsp;</span>
                  </h5>
                </div>

                <div class="show multi-collapse" id=ID{{item.Id}}>
                  <div class="card-body p-0">
                    <div class="row mx-0">
                      <div class="scroll_outer NoSidePadding">
                        <div class="scroll_inner_small">
                          <div class="normal_table w-100">
                            <table class="table table-hover mb-0">
                              <thead>
                                <tr>
                                  <th scope="col">&nbsp;</th>
                                  <th scope="col" i18n="@@Unit_Size">Unit Type Size</th>
                                  <th scope="col" i18n="@@Unit_Size">Description</th>
                                  <th scope="col" i18n="@@Category">Category</th>
                                  <th scope="col" i18n="@@Capacity">Capacity</th>
                                  <th scope="col" i18n="@@Available_Units">Available Units</th>
                                  <th scope="col" i18n="@@Competitors_Avg">Competitor's Avg</th>
                                </tr>
                              </thead>
                              <tbody *ngFor="let unitTypeItems of item.UnitTypeList">
                                <tr class="par" *ngIf="unitTypeItems.display">
                                  <td>
                                    <a data-bs-toggle="collapse"
                                      [ngClass]="unitTypeItems.length > 1 ? 'collapsed tab_clic_1' : 'show tab_clic_1'"
                                      href=#IDUnitType{{unitTypeItems.UnitTypeId}} role="button" aria-expanded="true">
                                      <i class="fa rgt_arr_Unit fa-caret-left"></i>
                                    </a>
                                  </td>
                                  <td>{{unitTypeItems.UnitTypeSize}}
                                      <i class="fa fa-exclamation-triangle text-warning ms-2"
                                      title="Not Available for Reservation" *ngIf="unitTypeItems.Warning"></i>
                                  </td>
                                  <td>{{unitTypeItems?.Description}}</td>
                                  <td><img *ngIf="unitTypeItems.CategoryName != undefined || unitTypeItems.CategoryName != null" [src]="unitTypeItems.CategoryLargeImageURL" style="height: 30px;"
                                      [title]="unitTypeItems.CategoryName" /></td>
                                  <td>{{unitTypeItems.Capacity}}</td>
                                  <td>{{unitTypeItems.AvailableUnits}}</td>
                                  <td>
                                    <span *ngIf="unitTypeItems.CompetitorMarketRate?.IsMatched">{{unitTypeItems.CompetitorMarketRate.AverageOccupiedRent | currency:'USD':'symbol':'1.2-2'}}</span>
                                    <span class="list-icon" style="cursor:pointer;" title="View competitor rates"
                                      *ngIf="unitTypeItems.CompetitorMarketRate?.IsMatched" (click)="openCompetitorRateDetail(unitTypeItems, competitorRateDetailModal)"></span>
                                    <span class="globe-icon" style="cursor:pointer;" title="View competitor locations"
                                      *ngIf="unitTypeItems.CompetitorMarketRate?.IsMatched" (click)="openCompetitorMapModal(unitTypeItems, competitorMapModal)"></span>
                                  </td>
                                </tr>
                                <tr *ngIf="unitTypeItems.display" id=IDUnitType{{unitTypeItems.UnitTypeId}}
                                  class="show bg-white">
                                  <td colspan="7">
                                    <table class="inner_table table table-responsive table-hover mb-0">
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitNumber', unitTypeItems.UnitTypeId, item.Id)">Unit #
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitNumber'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitNumber'"></span>
                                          </th>
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('Status', unitTypeItems.UnitTypeId, item.Id)">Status
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'Status'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'Status'"></span>
                                          </th>
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('Floor', unitTypeItems.UnitTypeId, item.Id)">Floor
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'Floor'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'Floor'"></span>
                                          </th>
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitLevelAttributeModel', unitTypeItems.UnitTypeId, item.Id)">
                                            Attributes
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitLevelAttributeModel'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitLevelAttributeModel'"></span>
                                          </th>
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('Rent', unitTypeItems.UnitTypeId, item.Id)">Rent
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'Rent'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'Rent'"></span>
                                          </th>
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitLevelAmenitiesModel', unitTypeItems.UnitTypeId, item.Id)">Amenities
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitLevelAmenitiesModel'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitLevelAmenitiesModel'"></span>
                                        
                                          <th class="sortable cursorUnitsSort"
                                            (click)="sortTable('UnitLevelDiscountModel', unitTypeItems.UnitTypeId, item.Id)">
                                            Specials
                                            <span class="fa fa-caret-down"
                                              *ngIf="unitTypeItems.SortType === 'dsc' && unitTypeItems.SortCol === 'UnitLevelDiscountModel'"></span>
                                            <span class="fa fa-caret-up"
                                              *ngIf="unitTypeItems.SortType === 'asc' && unitTypeItems.SortCol === 'UnitLevelDiscountModel'"></span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let unitList of unitTypeItems.UnitList">
                                          <td>
                                            <div class="buss_acc">
                                              <div class="custom-control-without-label custom-checkbox">
                                                <label class="pure-material-checkbox">
                                                  <input type="checkbox" [checked]="unitList.selected"
                                                    [(ngModel)]="unitList.selected"
                                                    [disabled]="(unitSelectionType == 'transfer' && unitList.Status !== 'Vacant')"
                                                    (click)="addUnitToList(unitList.UnitId, item.Id,unitTypeItems.UnitTypeId,  $event)">
                                                  <span></span>
                                                </label>
                                              </div>
                                            </div>
                                          </td>
                                          <td>{{unitList.UnitNumber}}</td>
                                          <td>{{unitList.Status}}</td>
                                          <td>{{unitList.Floor}}</td>
                                          <td><img class="me-2" *ngFor="let imgItem of unitList.UnitLevelAttributeModel"
                                              [src]="imgItem.LargeImageURL" [title]="imgItem.AttributeName"
                                              style="height: 30px;" /></td>
                                          <td>{{unitList.Rent | currency}} <span class="text-success"
                                              *ngIf="unitList.InternetPrice > 0">(Internet Price
                                              {{unitList.InternetPrice | currency}})
                                            </span>
                                            <span *ngIf="unitList.BudgetedRent > 0 && !unitList.InternetPrice && miscellaneousSettings?.DisplayBudgetedRent"
                                              class="text-success">
                                              (Budgeted Rent {{ unitList.BudgetedRent | currency}})</span>
                                            <div *ngIf="unitList.BudgetedRent > 0 && unitList.InternetPrice > 0 && miscellaneousSettings?.DisplayBudgetedRent"
                                              class="text-success">
                                              <span style="visibility: hidden">{{ unitList.Rent | currency }}</span>
                                              (Budgeted Rent {{ unitList.BudgetedRent | currency }})
                                            </div>
                                            <span *ngIf="unitList.PricingCategoryId" class="text-success">
                                              ({{unitList.PricingCategoryName}})</span></td>
                                            <td>
                                              <ol>
                                                <li *ngFor="let name of unitList.UnitLevelAmenitiesModel?.AmenityNames">
                                                  {{ name }}
                                                </li>
                                              </ol>
                                            </td>
                                            <td>
                                              <ol>
                                                <li *ngFor="let discItem of unitList.UnitLevelDiscountModel">
                                                  {{discItem.DiscountName}}</li>
                                              </ol>
                                            </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" i18n="@@Cancel"
           (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" id="selectcardview"
          [disabled]="selectedUnits.length === 0 && (selectedDate == ''|| selectedDate == null)"
          (click)="passSelectedUnits()" i18n="@@Select">Select</button>
      </div>
    </div>
  </div>
</div>

<!-- FR-15: Competitor's Avg List/Map icon detail modals, shared with adm-facilityinfodetails-unit (Story 5.1) -->
<ng-template #competitorRateDetailModal>
  <div class="modal-header competitor-rate-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
      <div class="header-text">
        <h5 class="modal-title">Competitor Rates</h5>
        <div class="header-subtitle">{{ selectedCompetitorUnitTypeName }} • {{ sqFt }} sq ft • within 10 mi of {{ selectedFacilityName }}</div>
      </div>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="competitorRateModalRef.hide()"></button>
  </div>
  <div class="competitor-rate-summary">
    <div class="summary-tiles">
      <div class="summary-tile your-rent">
        <div class="tile-label">YOUR NEW RENT</div>
        <div class="tile-value">
          {{ newRent | customCurrency }}
        </div>
      </div>
      <div class="summary-tile">
        <div class="tile-label">MARKET AVERAGE</div>
        <div class="tile-value">
          {{ marketAvg | customCurrency }}
        </div>
      </div>
      <div class="summary-tile">
        <div class="tile-label">RATE RANGE</div>
        <div class="tile-value">
          {{ minMarketRate | customCurrency }} –
          {{ maxMarketRate | customCurrency }}
        </div>
      </div>
    </div>
    <div class="market-insight">
      <i class="fa fa-line-chart" aria-hidden="true"></i>
      <span>
        Your new rent is
        <strong>{{ marketAvgPercentage }}%</strong>
        {{ marketDifferenceText }} the market average
        <span *ngIf="newRent < marketAvg">
          — room to increase toward market.
        </span>
      </span>
    </div>
  </div>
  <div class="modal-body">
    <app-competitor-rate-detail-list [competitorRates]="selectedCompetitorRates"></app-competitor-rate-detail-list>
  </div>
  <div class="competitor-rate-footer">
    <span>Your new rent</span>
    <strong>{{ newRent | customCurrency }}</strong>
    <span class="footer-separator">•</span>
    <span>Market avg</span>
    <strong>{{ marketAvg | customCurrency }}</strong>
  </div>
</ng-template>
<ng-template #competitorMapModal>
  <div class="modal-header competitor-rate-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fa fa-map" aria-hidden="true"></i>
      </div>
      <div class="header-text">
        <h5 class="modal-title">Competitor Rates — Map View </h5>
        <div class="header-subtitle">{{ selectedCompetitorUnitTypeName }} • {{ sqFt }} sq ft • within 10 mi of {{ selectedFacilityName }}</div>
      </div>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="competitorMapModalRef.hide()"></button>
  </div>
  <div class="competitor-rate-summary">
    <div class="summary-tiles">
      <div class="summary-tile your-rent">
        <div class="tile-label">YOUR NEW RENT</div>
        <div class="tile-value">
          {{ newRent | customCurrency }}
        </div>
      </div>
      <div class="summary-tile">
        <div class="tile-label">MARKET AVERAGE</div>
        <div class="tile-value">
          {{ marketAvg | customCurrency }}
        </div>
      </div>
      <div class="summary-tile">
        <div class="tile-label">RATE RANGE</div>
        <div class="tile-value">
          {{ minMarketRate | customCurrency }} –
          {{ maxMarketRate | customCurrency }}
        </div>
      </div>
    </div>
    <div class="market-insight">
      <i class="fa fa-line-chart" aria-hidden="true"></i>
      <span>
        Your new rent is
        <strong>{{ marketAvgPercentage }}%</strong>
        {{ marketDifferenceText }} the market average
        <span *ngIf="newRent < marketAvg">
          — room to increase toward market.
        </span>
      </span>
    </div>
  </div>
  <div class="modal-body">
    <app-competitor-market-map [ownName]="facilityMapLocation?.FacilityName"
                               [ownLatitude]="facilityMapLocation?.Latitude" [ownLongitude]="facilityMapLocation?.Longitude"
                               [pins]="selectedCompetitorMapPins" height="350px"></app-competitor-market-map>
  </div>
  <div class="competitor-rate-footer">
    <span>Your new rent</span>
    <strong>{{ newRent | customCurrency }}</strong>
    <span class="footer-separator">•</span>
    <span>Market avg</span>
    <strong>{{ marketAvg | customCurrency }}</strong>
  </div>
</ng-template>
